import { InsightsOverTimeBinDtoModelSelector } from '../../../models';

export const completedRoutesFragment = (selector: InsightsOverTimeBinDtoModelSelector) => selector.interval.value;
